import { useState, useCallback } from 'react';
import api from '../api/client';

const usePutURL = () => {
  const [isGrabando, setGrabando] = useState(false);
  const [erroresPut, setErroresPut] = useState(null);

  const putData = useCallback(async (path, datos, datosGrabados) => {
    setGrabando(true);
    setErroresPut(null);
    try {
      const res = await api.put(path, datos);
      if (res.ok) {
        const location = res.headers?.get?.('Location') ?? null;
        datosGrabados(location ?? res.data ?? null);
      } else {
        setErroresPut(res.errors ?? ['Error al insertar los datos']);
      }
    } catch (error) {
      console.error('Error Put', error.message ?? error);
      setErroresPut(['Error al insertar los datos']);
    }
    setGrabando(false);
  }, []);

  const resetErroresPut = useCallback(() => {
    setErroresPut(null);
  }, []);

  return { isGrabando, erroresPut, putData, resetErroresPut };
};

export default usePutURL;
